module.exports = __webpack_public_path__ + "static/img/Welcome_to_TOZO_Community.a60161cb.png";